import React from 'react';
import './CalibrationForm.css';

export default function CalibrationForm({ standalone = true, roomId, cage }) {
  const [activeTab, setActiveTab] = React.useState('Overview');
  const displayName = roomId || "Flower #18";
  const lastCalDate = cage?.lastCalDate || "—";
  const today = new Date().toISOString().slice(0, 10);

  return (
    <div className={`cal-form-container ${!standalone ? "cal-form-container-embedded" : ""}`}>
      <div className="cal-form-header">
        <div className="cal-form-title">
          <div className="cal-icon-wrapper">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"/><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/></svg>
          </div>
          <div>
            <h2>{displayName}</h2>
            <span className="cal-subtitle">{displayName} · Calibration</span>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <div style={{ background: '#166534', color: '#ffffff', fontSize: '12px', padding: '4px 10px', borderRadius: '12px', fontWeight: '500' }}>Online</div>
          <button className="cal-close-btn">×</button>
        </div>
      </div>

      <div style={{ display: 'flex', borderBottom: '1px solid #e2e8f0', padding: '0 20px', backgroundColor: '#ffffff' }}>
        {['Overview', 'Devices', 'Alarms', 'History'].map(tab => (
          <button 
            key={tab}
            onClick={() => setActiveTab(tab)}
            style={{
              background: 'none', border: 'none', padding: '16px 12px', fontSize: '13px', fontWeight: '500', cursor: 'pointer',
              color: activeTab === tab ? '#166534' : '#64748b',
              borderBottom: activeTab === tab ? '2px solid #166534' : '2px solid transparent',
              marginBottom: '-1px'
            }}
          >
            {tab}
          </button>
        ))}
      </div>

      {activeTab === 'Overview' && (
        <>
          <div className="cal-section">
        <div className="cal-section-title">GENERAL INFORMATION</div>
        <div className="cal-grid-4">
          <div className="cal-field">
            <label>Room</label>
            <input type="text" defaultValue={displayName} readOnly />
          </div>
          <div className="cal-field">
            <label>Date</label>
            <div className="cal-date-input">
              <input type="text" defaultValue={today} readOnly />
              <span className="cal-icon">📅</span>
            </div>
          </div>
          <div className="cal-field">
            <label>Temp Cage #</label>
            <input type="text" defaultValue="T5081" readOnly />
          </div>
          <div className="cal-field">
            <label>Hum Cage #</label>
            <input type="text" defaultValue="A5081" readOnly />
          </div>
        </div>

        <div className="cal-grid-4" style={{ marginTop: '16px' }}>
          <div className="cal-field">
            <label>Last Calibration</label>
            <input type="text" defaultValue={lastCalDate} readOnly />
          </div>
          <div className="cal-field">
            <label>Calibration Device</label>
            <select defaultValue="">
              <option value="" disabled>Select device...</option>
            </select>
          </div>
          <div className="cal-field">
            <label>Light</label>
            <div className="cal-toggle-group">
              <button className="cal-toggle active">ON</button>
              <button className="cal-toggle">OFF</button>
            </div>
          </div>
          <div className="cal-field">
            <label>Plants Present?</label>
            <div className="cal-toggle-group">
              <button className="cal-toggle active">Yes</button>
              <button className="cal-toggle">No</button>
            </div>
          </div>
        </div>
      </div>

      <div className="cal-grid-2">
        <div className="cal-section">
          <div className="cal-section-title">
             <span style={{marginRight: '6px'}}>🌡</span> TEMPERATURE VERIFICATION
          </div>
          <div className="cal-grid-3">
            <div className="cal-field">
              <label>Actual (F°)</label>
              <input type="text" defaultValue="76.79" />
            </div>
            <div className="cal-field">
              <label>Target (F°)</label>
              <input type="text" defaultValue="79" />
            </div>
            <div className="cal-field">
              <label>Diff (F°)</label>
              <div className="cal-diff-value warning">-2.2</div>
            </div>
          </div>
          <div className="cal-alert warning-bg">
            Cal required? Yes (&gt;±2°F)
          </div>
        </div>

        <div className="cal-section">
          <div className="cal-section-title">
            <span style={{marginRight: '6px'}}>💧</span> RELATIVE HUMIDITY VERIFICATION
          </div>
          <div className="cal-grid-3">
            <div className="cal-field">
              <label>Actual (%)</label>
              <input type="text" defaultValue="66.1" />
            </div>
            <div className="cal-field">
              <label>Target (%)</label>
              <input type="text" defaultValue="66.2" />
            </div>
            <div className="cal-field">
              <label>Diff (%)</label>
              <div className="cal-diff-value">—</div>
            </div>
          </div>
        </div>
      </div>

      <div className="cal-section cal-section-highlight">
        <div className="cal-section-title">TEMPERATURE CALIBRATION</div>
        <p className="cal-help-text">Modify the converted measurement with the difference between the ice point value (32.8 F°) and the Damatex Instant Value.</p>
        
        <div className="cal-table">
          <div className="cal-table-header">
            <div></div>
            <div>Cal. per unit</div>
            <div>Unconverted</div>
            <div>Converted</div>
          </div>
          <div className="cal-table-row">
            <div className="cal-row-label">Actual</div>
            <div><input type="text" /></div>
            <div><input type="text" /></div>
            <div><input type="text" /></div>
          </div>
          <div className="cal-table-row">
            <div className="cal-row-label">Modified</div>
            <div><input type="text" /></div>
            <div><input type="text" /></div>
            <div><input type="text" /></div>
          </div>
        </div>
      </div>

      <div className="cal-section">
        <div className="cal-section-title">COMMENTS</div>
        <textarea className="cal-textarea" placeholder="Additional notes..."></textarea>
      </div>

      <div className="cal-footer">
        <button className="cal-btn-cancel">Cancel</button>
        <button className="cal-btn-save">Save Calibration</button>
      </div>
        </>
      )}
    </div>
  );
}
